import React from 'react';
import { ChevronRight } from 'lucide-react';
export function FascinationsSection() {
  const bullets = [{
    title: 'El Sabotaje de las 8 AM:',
    text: <span data-id="element-48">
          Por qué ese desayuno "saludable" que te recomendaron es el responsable
          de tu{' '}
          <strong className="text-background" data-id="element-49">
            caída de energía y falta de enfoque
          </strong>{' '}
          antes del mediodía.
        </span>
  }, {
    title: 'La Bóveda de Energía:',
    text: <span data-id="element-50">
          El secreto biológico para que tu cerebro{' '}
          <strong className="text-background" data-id="element-51">
            deje de depender de "energía barata"
          </strong>{' '}
          y acceda a un flujo de combustible ultra-estable.
        </span>
  }, {
    title: 'El Interruptor de la Claridad:',
    text: <span data-id="element-52">
          Cómo reducir la{' '}
          <strong className="text-background" data-id="element-53">
            neuro-inflamación silenciosa
          </strong>{' '}
          que te hace sentir <strong className="text-amber" data-id="element-54">"atontado"</strong>{' '}
          y lento durante tus horas más importantes.
        </span>
  }, {
    title: 'El Protocolo de 72 Horas:',
    text: <span data-id="element-55">
          El paso a paso exacto para{' '}
          <strong className="text-background" data-id="element-56">
            resetear tu química interna
          </strong>{' '}
          y que tu{' '}
          <strong className="text-background" data-id="element-57">
            procesamiento mental vuelva a funcionar a máxima potencia
          </strong>
          .
        </span>
  }];
  return <section className="py-4 md:py-14 px-6 bg-navy text-background" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-12 text-center leading-tight" data-id="element-60">
          Lo que <span className="text-amber" data-id="element-61">nadie te cuenta</span> y que vas a
          descubrir en minutos:
        </h2>

        <div className="space-y-6" data-id="element-62">
          {bullets.map((bullet, index) => <div key={index} className="flex items-start gap-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-63">
              <div className="mt-1 flex-shrink-0" data-id="element-64">
                <ChevronRight className="w-6 h-6 text-amber" data-id="element-65" />
              </div>
              <p className="text-lg md:text-xl leading-relaxed" data-id="element-66">
                <strong className="text-amber font-semibold" data-id="element-67">
                  {bullet.title}
                </strong>{' '}
                {bullet.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}